import { render } from "./fb1.vue?vue&type=template&id=5edfc95a&scoped=true"
import script from "./fb1.vue?vue&type=script&lang=js"
export * from "./fb1.vue?vue&type=script&lang=js"

import "./fb1.vue?vue&type=style&index=0&id=5edfc95a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edfc95a"]])

export default __exports__